import React from 'react'
import './home.css';

const Home = () => {
  
  return (
    <div className='home'>
      
    </div>
  )
}

export default Home